import { ReduxAction } from '../../types/common';
import { SET_ERRORS, GET_CONTRACTS } from '../actionTypes';
import { Contract } from './clients';

interface ContractState {
  contracts: Contract[]
}

const INITIAL_STATE = {
  contracts: []
}

export const contracts = (state: ContractState = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case GET_CONTRACTS:
      return {
          ...state,
          contracts: action.payload,
      }
    case SET_ERRORS:
      return {
          ...state,
          errors: action.payload,
      }
    default:
      return state
  }
}